import React from "react";
import ReactMarkdown from "react-markdown";
import { Box, Typography } from "@mui/material";

export const MessageBubble = ({ message }) => {
  const isUser = message.role === "user";
  const isError = message.isError;

  return (
    <Box
      sx={{
        display: "flex",
        justifyContent: isUser ? "flex-end" : "flex-start",
        mb: 2,
      }}
    >
      <Box
        sx={{
          maxWidth: "80%",
          p: 2,
          borderRadius: 2,
          backgroundColor: isError
            ? "error.main"
            : isUser
              ? "primary.main"
              : "background.paper",
          color: isError || isUser ? "white" : "text.primary",
        }}
      >
        {!isUser && !isError ? (
          <ReactMarkdown>{message.content}</ReactMarkdown>
        ) : (
          <Typography variant="body1">{message.content}</Typography>
        )}
      </Box>
    </Box>
  );
};
